// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#bring-business form fieldset{border:1px solid #104182;border-radius:.35rem}#bring-business form fieldset legend{color:#104182;font-size:1.5rem;width:auto}@media (max-width: 767.98px){#bring-business form fieldset legend{font-size:1.2rem}}\n", ""]);
// Exports
module.exports = exports;
